import { IconName } from 'components/atoms/Icon/types'
import { TableBuildActionsType } from './type'

export const TableBuildActionsIconDefault: Record<
    Exclude<TableBuildActionsType, 'SWITCH'>,
    IconName
> = {
    CREATE: 'add',
    EDIT: 'edit',
    DELETE: 'delet',
    PREVIEW: 'eye',
    DOWNLOAD: 'download',
    RETURNFILE: 'comment-lines',
    DOWNLOADLOTE: 'file-alt'
}
